

/* ==========================================================================
   HELM  ·  storefront masthead controller
   Architecture: one config + a single delegated ACTION BUS that dispatches
   [data-hm-act] to registered handlers, plus a few self-contained behaviours
   (sticky via IntersectionObserver, finder, overlays, tree stack, cart).
   No per-element listeners for actions; no scroll handler for sticky.
   ========================================================================== */
(function () {
  'use strict';

  var cfgNode = document.querySelector('[data-hm-config]');
  var CFG = cfgNode ? JSON.parse(cfgNode.textContent) : {};
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function coin(cents) {
    var v = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (CFG.money || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* ---- the action bus ---------------------------------------------------- */
  var ACT = Object.create(null);
  function act(name, fn) { ACT[name] = fn; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hm-act]');
    if (!t) return;
    var fn = ACT[t.getAttribute('data-hm-act')];
    if (!fn) return;
    fn(t, e);
  });

  /* ====================================================================
     CONDENSE  ·  scroll-position detection
     IntersectionObserver fails when the section is position:fixed (the
     sentinel no longer moves with the page). Direct scroll-position is
     reliable and gives us scroll-direction for the announcement reveal.
     ==================================================================== */
  (function condense() {
    var shell = qs('[data-hm="shell"]');
    var section = qs('.helm-masthead');
    if (!shell || shell.getAttribute('data-stick') !== 'true') return;
    var at = Number(CFG.stickAt); if (isNaN(at)) at = 80;
    var lastY = 0;
    function apply() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var condensed = y > at;
      shell.setAttribute('data-condensed', condensed ? 'true' : 'false');
      if (section) section.setAttribute('data-condensed', condensed ? 'true' : 'false');
      lastY = y;
    }
    apply();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply, { passive: true });
  })();

  /* ====================================================================
     FLYOUTS  ·  CSS drives hover; JS adds keyboard + focus state
     ==================================================================== */
  (function flyouts() {
    var shell = qs('[data-hm="shell"]');
    qa('[data-hm="navitem"].has-fly').forEach(function (node) {
      var link = qs('.hm-nav__link', node);
      var set = function (open) {
        node.classList.toggle('is-open', open);
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (shell) shell.classList.toggle('is-flyopen', !!qs('[data-hm="navitem"].is-open'));
      };
      node.addEventListener('mouseenter', function () { set(true); });
      node.addEventListener('focusin', function () { set(true); });
      node.addEventListener('focusout', function (e) { if (!node.contains(e.relatedTarget)) set(false); });
      node.addEventListener('mouseleave', function () { set(false); });
      if (link) link.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); link.blur(); } });
    });
    // image-grid rail: swap tab on hover/click (delegated, scoped to navbar)
    var navbar = qs('[data-hm="navbar"]');
    if (navbar) {
      var swap = function (tab) {
        var rail = tab.closest('[data-hm-rail]'); if (!rail) return;
        var i = tab.getAttribute('data-hm-tab');
        qa('[data-hm-tab]', rail).forEach(function (b) { var on = b === tab; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        qa('[data-hm-tabpanel]', rail).forEach(function (p) { var on = p.getAttribute('data-hm-tabpanel') === i; p.classList.toggle('is-on', on); p.hidden = !on; });
      };
      navbar.addEventListener('click', function (e) { var t = e.target.closest('[data-hm-tab]'); if (t) swap(t); });
      navbar.addEventListener('mouseover', function (e) {
        var t = e.target.closest('[data-hm-tab]'); if (!t || t.classList.contains('is-on')) return;
        var r = t.closest('[data-hm-rail]'); if (r && r.getAttribute('data-hm-hover-tabs') === 'false') return;
        swap(t);
      });
    }
  })();

  /* ====================================================================
     OVERLAYS  ·  tree + cart  (scroll-lock + focus trap)
     ==================================================================== */
  var Overlay = (function () {
    var live = null, prior = null;
    var grabbable = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
    function open(name) {
      var el = qs('[data-hm="overlay"][data-name="' + name + '"]'); if (!el) return;
      prior = document.activeElement;
      el.setAttribute('aria-hidden', 'false'); el.classList.add('is-live');
      document.documentElement.classList.add('hm-locked');
      live = el;
      if (name === 'tree') Tree.reset(el);
      qa('[data-hm-act="openOverlay"][data-name="' + name + '"], [data-hm-act="menuToggle"][data-name="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var f = qs(grabbable, el); if (f) f.focus();
    }
    function close() {
      if (!live) return;
      live.setAttribute('aria-hidden', 'true'); live.classList.remove('is-live');
      document.documentElement.classList.remove('hm-locked');
      var name = live.getAttribute('data-name');
      qa('[data-hm-act="openOverlay"][data-name="' + name + '"], [data-hm-act="menuToggle"][data-name="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      live = null;
      if (prior) prior.focus();
    }
    document.addEventListener('keydown', function (e) {
      if (!live) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = qa(grabbable, live).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    return { open: open, close: close, current: function () { return live; } };
  })();
  act('openOverlay', function (t) { Overlay.open(t.getAttribute('data-name')); });
  act('closeOverlay', function () { Overlay.close(); });

  /* menuToggle — desktop: toggle the nav row; mobile: open the drawer.
     Always animates the burger to an X via [aria-expanded]. */
  act('menuToggle', function (t) {
    var isDesktop = window.matchMedia('(min-width:990px)').matches;
    if (isDesktop) {
      var shell = qs('[data-hm="shell"]');
      var open = shell.getAttribute('data-nav-open') === 'true';
      shell.setAttribute('data-nav-open', open ? 'false' : 'true');
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
    } else {
      Overlay.open(t.getAttribute('data-name'));
    }
  });

  /* ====================================================================
     TREE  ·  panel-stack drill-down
     ==================================================================== */
  var Tree = (function () {
    var root = null, stack = ['root'];
    function panel(name) { return root ? qs('[data-hm-panel="' + name + '"]', root) : null; }
    function reset(scope) {
      root = qs('[data-hm-tree]', scope) || scope;
      stack = ['root'];
      qa('[data-hm-panel]', root).forEach(function (p) {
        var isRoot = p.getAttribute('data-hm-panel') === 'root';
        p.classList.toggle('is-front', isRoot);
        p.classList.remove('is-rear');
        p.hidden = !isRoot;
      });
    }
    function push(name) {
      var nxt = panel(name); if (!nxt) return;
      var cur = panel(stack[stack.length - 1]);
      nxt.hidden = false;
      /* Commit the just-shown panel's layout + paint NOW. `contain` in CSS
         scopes this to the panel, so it's cheap — but it's essential on iOS
         Safari, which otherwise leaves the panel laid-out-but-unpainted
         (a blank white panel) for several seconds until some later repaint.
         This also registers the translateX(100%) start state so the slide
         animates cleanly instead of snapping. */
      void nxt.offsetWidth;
      requestAnimationFrame(function () {
        if (cur) { cur.classList.remove('is-front'); cur.classList.add('is-rear'); }
        nxt.classList.add('is-front');
      });
      stack.push(name);
      /* preventScroll avoids a scroll-into-view reflow on every tap */
      var first = qs('a,button', nxt);
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
    function pop() {
      if (stack.length < 2) return;
      var cur = panel(stack.pop());
      var prev = panel(stack[stack.length - 1]);
      if (cur) cur.classList.remove('is-front');
      if (prev) { prev.classList.remove('is-rear'); prev.classList.add('is-front'); }
      setTimeout(function () { if (cur) cur.hidden = true; }, calm ? 0 : 260);
    }
    return { reset: reset, push: push, pop: pop };
  })();
  act('treeOpen', function (t) { Tree.push(t.getAttribute('data-target')); });
  act('treeBack', function () { Tree.pop(); });

  /* ====================================================================
     ANNOUNCEMENT  ·  rotate
     ==================================================================== */
  (function announce() {
    var bar = qs('[data-hm="announce"]'); if (!bar) return;
    var slides = qa('[data-hm-ann-slide]', bar); if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) { slides[i].classList.remove('is-on'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-on'); }
    function run() { if (!calm) timer = setInterval(function () { go(i + 1); }, 5000); }
    act('annPrev', function () { clearInterval(timer); go(i - 1); run(); });
    act('annNext', function () { clearInterval(timer); go(i + 1); run(); });
    run();
  })();

  /* ====================================================================
     FINDER  ·  predictive search
     ==================================================================== */
  function Finder(scope) {
    this.scope = scope;
    this.input = qs('[data-hm-find]', scope);
    this.drop = qs('[data-hm-drop]', scope);
    this.body = qs('[data-hm-drop-body]', scope);
    this.busy = qs('[data-hm-drop-busy]', scope);
    this.hits = [];
    this.cur = -1;
    this._token = 0;     /* guards against out-of-order async responses */
    this._cache = {};    /* per-collection Set of product handles */
    if (this.input && this.drop) this.wire();
  }
  Finder.prototype.wire = function () {
    var self = this;
    this.input.addEventListener('input', debounce(function () { self.run(); }, 240));
    this.input.addEventListener('focus', function () { if (self.input.value.trim()) self.open(); });
    this.input.addEventListener('keydown', function (e) { self.key(e); });
    document.addEventListener('click', function (e) { if (!self.scope.contains(e.target)) self.shut(); });
    /* re-run when the category scope changes */
    var scopeEl = qs('[data-hm-scope]', this.scope);
    if (scopeEl) scopeEl.addEventListener('change', function () { if (self.input.value.trim().length >= 2) self.run(); });
    /* on submit, if a category is chosen, scope the search results page to it */
    var form = qs('form', this.scope);
    if (form) form.addEventListener('submit', function (e) {
      var sc = qs('[data-hm-scope]', self.scope);
      if (sc && sc.value) {
        e.preventDefault();
        var q = encodeURIComponent(self.input.value.trim());
        window.location.href = CFG.root + 'search?q=' + q + '&type=product&options[prefix]=last&filter.p.collection=' + encodeURIComponent(sc.value);
      }
    });
  };
  Finder.prototype.open = function () { this.drop.hidden = false; this.input.setAttribute('aria-expanded', 'true'); };
  Finder.prototype.shut = function () { this.drop.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.cur = -1; };
  /* Resolve a Set of product handles that belong to `handle` (cached).
     Resolves to a Set on success (possibly empty for an empty collection),
     or null if the collection could not be fetched — so the caller can tell
     "no products in category" apart from "lookup failed". */
  Finder.prototype.collHandles = function (handle) {
    var self = this;
    if (this._cache[handle] !== undefined) return Promise.resolve(this._cache[handle]);
    var base = (CFG.root || '/').replace(/\/+$/, '');
    var set = {};                 /* plain-object Set shim (older browser safe) */
    var keys = 0;
    var page = function (n) {
      var u = base + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n;
      return fetch(u, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) {
          var ps = (d && d.products) ? d.products : [];
          for (var i = 0; i < ps.length; i++) { if (ps[i].handle && !set[ps[i].handle]) { set[ps[i].handle] = 1; keys++; } }
          if (ps.length === 250 && n < 4) return page(n + 1);   /* cap at 1000 products */
          return set;
        });
    };
    return page(1)
      .then(function (s) { self._cache[handle] = s; return s; })
      .catch(function () { self._cache[handle] = null; return null; });
  };
  Finder.prototype.run = function () {
    var self = this, q = this.input.value.trim();
    if (q.length < 2) { this.shut(); return; }
    this.open();
    if (this.busy) this.busy.hidden = false;
    var token = ++this._token;            /* every keystroke supersedes the last */
    var n = CFG.limit || 6;
    var scopeEl = qs('[data-hm-scope]', this.scope);
    var scopeHandle = scopeEl ? scopeEl.value : '';
    var reqLimit = scopeHandle ? 10 : n;  /* over-fetch when filtering so we still fill n */
    var url = CFG.predict + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=' + reqLimit +
      '&resources[options][unavailable_products]=last';

    /* always clears THIS request's spinner, on success, failure, or supersession */
    var done = function () { if (token === self._token && self.busy) self.busy.hidden = true; };

    var predict = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });

    var work;
    if (scopeHandle) {
      work = Promise.all([predict, this.collHandles(scopeHandle)]).then(function (arr) {
        var d = arr[0], set = arr[1];
        var res = (d && d.resources && d.resources.results) ? d.resources.results : {};
        if (res.products && res.products.length) {
          if (set) {
            /* strict filter: keep only products whose handle is in the chosen collection */
            res.products = res.products.filter(function (p) { return p.handle && set[p.handle]; }).slice(0, n);
          } else {
            /* collection lookup failed — degrade gracefully rather than hiding everything */
            res.products = res.products.slice(0, n);
          }
        }
        return res;
      });
    } else {
      work = predict.then(function (d) {
        return (d && d.resources && d.resources.results) ? d.resources.results : {};
      });
    }

    work.then(function (res) {
      if (token !== self._token) return;   /* a newer search already rendered */
      self.paint(res, q);
    }).catch(function () {
      if (token !== self._token) return;
      self.body.innerHTML = '<p class="hm-find__none">Search unavailable.</p>';
    }).then(done, done);
  };
  Finder.prototype.hit = function (p) {
    var img = p.image || p.featured_image || (p.images && p.images[0]) || '';
    var cost = typeof p.price === 'number' ? coin(p.price) : (p.price || '');
    return '<a class="hm-find__hit" role="option" href="' + p.url + '">' +
      (img ? '<img class="hm-find__hit-pic" src="' + img + '" alt="" loading="lazy" width="44" height="44">' : '') +
      '<span class="hm-find__hit-main"><span class="hm-find__hit-name">' + p.title + '</span>' +
      (cost ? '<span class="hm-find__hit-cost">' + cost + '</span>' : '') + '</span></a>';
  };
  Finder.prototype.simple = function (cap, list) {
    return '<div class="hm-find__group"><p class="hm-find__group-cap">' + cap + '</p>' +
      list.map(function (i) { return '<a class="hm-find__hit hm-find__hit--flat" role="option" href="' + i.url + '">' + i.title + '</a>'; }).join('') + '</div>';
  };
  Finder.prototype.paint = function (r, q) {
    var h = '';
    if (r.products && r.products.length) h += '<div class="hm-find__group"><p class="hm-find__group-cap">Products</p>' + r.products.map(this.hit, this).join('') + '</div>';
    if (r.collections && r.collections.length) h += this.simple('Collections', r.collections);
    if (r.pages && r.pages.length) h += this.simple('Pages', r.pages);
    if (r.articles && r.articles.length) h += this.simple('Articles', r.articles);
    if (!h) h = '<p class="hm-find__none">No results for \u201c' + q + '\u201d.</p>';
    else h += '<a class="hm-find__all" href="' + CFG.root + 'search?q=' + encodeURIComponent(q) + '">View all results</a>';
    this.body.innerHTML = h;
    this.hits = qa('[role="option"]', this.body); this.cur = -1;
  };
  Finder.prototype.key = function (e) {
    if (!this.hits.length) { if (e.key === 'Escape') this.shut(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); this.move(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.move(-1); }
    else if (e.key === 'Enter' && this.cur > -1) { e.preventDefault(); this.hits[this.cur].click(); }
    else if (e.key === 'Escape') { this.shut(); this.input.blur(); }
  };
  Finder.prototype.move = function (d) {
    this.hits.forEach(function (o) { o.classList.remove('is-cued'); });
    this.cur = (this.cur + d + this.hits.length) % this.hits.length;
    var o = this.hits[this.cur]; o.classList.add('is-cued'); o.scrollIntoView({ block: 'nearest' });
  };
  qa('[data-hm="finder"]').forEach(function (el) { new Finder(el); });

  /* ====================================================================
     CART  ·  Section Rendering API
     ==================================================================== */
  var Cart = (function () {
    var SECTION = 'helm-minicart';
    function counts(n) { qa('[data-hm-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-zero', n === 0); }); }
    function graft(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nb = doc.querySelector('[data-hm-cart-body]'), nf = doc.querySelector('[data-hm-cart-foot]');
      var cb = qs('#hm-cart [data-hm-cart-body]'), cf = qs('#hm-cart [data-hm-cart-foot]'), sheet = qs('#hm-cart .hm-cart');
      if (nb && cb) cb.innerHTML = nb.innerHTML;
      if (cf && nf) cf.replaceWith(nf); else if (cf && !nf) cf.remove(); else if (!cf && nf && sheet) sheet.appendChild(nf);
      var c = doc.querySelector('[data-hm-count]'); if (c) counts(parseInt(c.textContent, 10) || 0);
    }
    function pull() { return fetch(CFG.root + '?sections=' + SECTION).then(function (r) { return r.json(); }).then(function (d) { if (d[SECTION]) graft(d[SECTION]); }).catch(function () {}); }

    /* Core add. Accepts either:
         - a variant id (string/number), with optional quantity
         - a FormData object from a real /cart/add form (covers line-item
           properties, selling plans, multi-variant adds, file inputs, etc.)
       The Section Rendering API does the mini-cart refresh in the same
       round-trip as the add, so the drawer opens already up-to-date. */
    function add(payload, opts) {
      opts = opts || {};
      var init = { method: 'POST', headers: { Accept: 'application/json' } };
      if (payload && typeof FormData !== 'undefined' && payload instanceof FormData) {
        payload.set('sections', SECTION);
        init.body = payload;
      } else {
        init.headers['Content-Type'] = 'application/json';
        init.body = JSON.stringify({ items: [{ id: payload, quantity: opts.quantity || 1 }], sections: SECTION });
      }
      return fetch(CFG.add, init)
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.data || { description: 'Add to cart failed' };
          if (res.data.sections && res.data.sections[SECTION]) graft(res.data.sections[SECTION]); else return pull().then(function () { return res.data; });
          return res.data;
        })
        .then(function (item) {
          if (opts.open !== false) Overlay.open('cart');
          document.dispatchEvent(new CustomEvent('helm:cart:added', { bubbles: true, detail: { item: item } }));
          return item;
        });
    }
    function set(key, q) {
      return fetch(CFG.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q, sections: SECTION }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d.sections && d.sections[SECTION]) graft(d.sections[SECTION]); else return pull(); });
    }
    var note = debounce(function (v) { fetch(CFG.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }); }, 600);
    function rowQty(key) { var i = qs('[data-hm-qty][data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]'); return i ? (parseInt(i.value, 10) || 0) : 0; }

    /* Button busy-state helper — one place that knows how to mark/unmark
       any add-to-cart button across the theme. Handlers below all flow
       through this so spinner behavior is consistent everywhere. */
    function busy(btn, on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
      btn.classList.toggle('is-busy', on);
      if (on) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      else    { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }

    /* High-level helper used by the global handlers — wraps add() with the
       button busy state and error dispatch so each call site doesn't repeat
       it. `source` is a label that flows through to listeners (e.g. 'form',
       'qv', 'quickAdd') so analytics or A/B logic can branch on origin. */
    function addFrom(payload, btn, source, opts) {
      busy(btn, true);
      return add(payload, opts).then(function (item) {
        busy(btn, false);
        return item;
      }).catch(function (err) {
        busy(btn, false);
        document.dispatchEvent(new CustomEvent('helm:cart:error', { bubbles: true, detail: { error: err, source: source } }));
        if (window.console && console.warn) console.warn('[helm cart] add failed:', err);
        throw err;
      });
    }

    /* ── GLOBAL ADD-TO-CART INTERCEPTORS ──────────────────────────────
       Any future section that uses a real <form action="/cart/add"> or a
       button with data-hm-cart-add / [data-variant] is wired automatically. */

    /* 1) Forms: capture-phase submit intercept on any form whose action
       ends in /cart/add. Opt-out with `data-hm-cart-no-intercept`. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.hasAttribute('data-hm-cart-no-intercept')) return;
      var act = form.getAttribute('action') || '';
      if (!/\/cart\/add(\b|\?|\/|$)/.test(act)) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"],[data-hm-cart-add],[data-ppp-add],.qv-add-cart,.btn-cart,[name="add"]');
      addFrom(new FormData(form), btn, 'form');
    }, true);

    /* 2) Buttons that aren't inside a form — declarative API:
       <button data-hm-cart-add="VARIANT_ID" data-quantity="2">…</button>
       Also matches the existing `data-hm-act="quickAdd"` buttons and any
       button carrying a `data-variant` on its own. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hm-cart-add],[data-hm-act="quickAdd"]');
      if (!btn) return;
      /* Don't double-handle: if the button lives in a form we'll
         already intercept on submit. */
      if (btn.closest('form[action*="/cart/add"]')) return;
      var id = btn.getAttribute('data-hm-cart-add') || btn.getAttribute('data-variant');
      if (!id) return;
      e.preventDefault();
      var q = parseInt(btn.getAttribute('data-quantity'), 10);
      addFrom(id, btn, btn.getAttribute('data-hm-act') === 'quickAdd' ? 'quickAdd' : 'button', { quantity: q > 0 ? q : 1 });
    });

    /* 3) Programmatic API for sections that already do their own UI work
       (Quick View opens a modal, Product Page validates options, etc.).
       They dispatch:
         document.dispatchEvent(new CustomEvent('helm:cart:add',
           { detail: { id, quantity, formData, button } }));
       …and the response flows back as 'helm:cart:added' / 'helm:cart:error'. */
    document.addEventListener('helm:cart:add', function (e) {
      var d = (e && e.detail) || {};
      var payload = d.formData || d.id;
      if (!payload) return;
      addFrom(payload, d.button || null, d.source || 'event', { quantity: d.quantity, open: d.open !== false });
    });

    /* 4) Refresh-only signal — any section can ask the mini-cart to
       re-pull (e.g. after a custom mutation it performed itself). */
    document.addEventListener('helm:cart:refresh', function () { pull(); });
    /* Back-compat: the premium product page emits these names. */
    document.addEventListener('cart:refresh', function () { pull(); });
    document.addEventListener('ppp:cart:added', function () { Overlay.open('cart'); pull(); });

    act('qtyUp', function (t) { var k = t.getAttribute('data-key'); set(k, rowQty(k) + 1); });
    act('qtyDown', function (t) { var k = t.getAttribute('data-key'); set(k, Math.max(0, rowQty(k) - 1)); });
    act('removeLine', function (t) { set(t.getAttribute('data-key'), 0); });
    document.addEventListener('change', function (e) {
      var q = e.target.closest('[data-hm-qty]'); if (q) set(q.getAttribute('data-key'), Math.max(0, parseInt(q.value, 10) || 0));
      var nt = e.target.closest('[data-hm-note]'); if (nt) note(nt.value);
    });
    return { add: add, addFrom: addFrom, set: set, pull: pull, busy: busy };
  })();

  /* ── STICKY HEADER ────────────────────────────────────────────
     position:fixed + JS-managed body padding. This bypasses every
     known position:sticky failure (ancestor overflow, transform,
     containing-block height). The header is pinned to the viewport
     and body gets padding-top equal to header height so content
     starts below it without layout shift on scroll.
  */
  function setupSticky() {
    var sec = qs('.helm-masthead'); if (!sec) return;
    var enabled = sec.querySelector('.hm-shell') && sec.querySelector('.hm-shell').getAttribute('data-stick') !== 'false';
    if (!enabled) return;
    sec.style.position = 'fixed';
    sec.style.top = '0';
    sec.style.left = '0';
    sec.style.right = '0';
    sec.style.zIndex = '900';
    function sync() {
      var h = sec.getBoundingClientRect().height || sec.offsetHeight;
      document.body.style.paddingTop = h + 'px';
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('load', sync);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(sec);
    /* re-sync after Theme Editor section reload */
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', sync);
  }
  setupSticky();

  /* ── PRODUCT SLIDER ARROWS ─────────────────────────────────────
     Desktop shelves use their built-in arrows. Tree (mobile) slider
     shelves get arrows injected so users see it's swipeable.
  */
  function wireSlider(rail, prev, next) {
    function step() {
      var first = rail.firstElementChild; if (!first) return 280;
      var style = getComputedStyle(rail);
      var gap = parseFloat(style.columnGap || style.gap) || 12;
      /* advance by one full "page" of visible cards */
      var per = Math.max(1, Math.round(rail.clientWidth / (first.getBoundingClientRect().width + gap)));
      return (first.getBoundingClientRect().width + gap) * per;
    }
    function update() {
      if (!prev || !next) return;
      /* Skip while the rail has no layout (panel still hidden in the drawer).
         Otherwise scrollWidth/clientWidth are both 0, max goes negative, and
         BOTH arrows get stuck disabled until something forces a re-measure. */
      if (!rail.clientWidth) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left:  step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    /* Re-measure as soon as the rail actually has a size. The mobile shelf
       lives inside an off-canvas panel that's display:none until the user
       drills into it — at wire time clientWidth is 0, so the initial update()
       would otherwise disable both arrows and they'd only recover after a
       manual swipe. ResizeObserver fires exactly when 0×0 → real size. */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(update);
      ro.observe(rail);
    }
    update();
  }
  function setupSliders() {
    /* desktop shelves with explicit prev/next buttons */
    qa('[data-hm-shelf]').forEach(function (sh) {
      var rail = sh.querySelector('.hm-shelf__rail.is-slider'); if (!rail) return;
      if (rail.dataset.hmWired) return; rail.dataset.hmWired = '1';
      wireSlider(rail, sh.querySelector('[data-hm-slider-prev]'), sh.querySelector('[data-hm-slider-next]'));
    });
    /* mobile tree slider shelves — inject arrows into the title-row nav slot */
    qa('.hm-shelf2.is-slider').forEach(function (shelf) {
      if (shelf.dataset.hmWired) return; shelf.dataset.hmWired = '1';
      var track = shelf.querySelector('[data-hm-shelf-track]'); if (!track) return;
      var nav = shelf.querySelector('[data-hm-shelf-nav]');
      var p = null, n = null;
      if (nav) {
        p = document.createElement('button'); p.type = 'button'; p.className = 'hm-shelf2__btn'; p.setAttribute('aria-label', 'Previous'); p.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>';
        n = document.createElement('button'); n.type = 'button'; n.className = 'hm-shelf2__btn'; n.setAttribute('aria-label', 'Next'); n.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>';
        nav.appendChild(p); nav.appendChild(n);
      }
      wireSlider(track, p, n);
    });
  }
  setupSliders();
  document.addEventListener('shopify:section:load', setupSliders);








/* ====================================================================
     PLAIN DROPDOWN · scrollable levels + viewport-aware placement
     --------------------------------------------------------------------
     REPLACES the v6.1 plainScroll block. Delete that one first.
     helm.css v6.1 is unchanged — do not touch it.

     Fixed in v6.2:
       · repositioning no longer wipes scrollTop (v6.1 set max-height to
         'none' to re-measure, which makes the box non-scrollable for an
         instant and forces scrollTop back to 0 — the panel could never
         advance past the first screenful)
       · natural height is read from scrollHeight instead of by mutating
         inline styles, so nothing is written during a scroll
       · natural width is cached once, killing the horizontal jitter
       · a panel is not repositioned in response to its own scrolling

     PASTE INSIDE helm.js, just above:
         window.Helm = { open: Overlay.open, ... };
     ==================================================================== */
  (function plainScroll() {
    var wide  = window.matchMedia('(min-width:990px)');
    var EDGE  = 20;    /* hard gap kept between panel and viewport edge */
    var LAP   = 1;     /* overlap the parent panel by a hair             */
    var GRACE = 260;   /* ms the panel survives after the pointer leaves */

    function vpH() { return (window.visualViewport && window.visualViewport.height) || window.innerHeight; }
    function vpW() { return (window.visualViewport && window.visualViewport.width)  || window.innerWidth;  }
    function px(v) { return parseFloat(v) || 0; }

    function subOf(item) {
      if (!item || !item.children) return null;
      for (var i = 0; i < item.children.length; i++) {
        if (item.children[i].classList.contains('hm-plain__sub')) return item.children[i];
      }
      return null;
    }

    /* ---------- geometry ---------- */

    /* Level 1 — the <ul> inside the panel takes the leftover height.
       Only written when the value actually changes, so a live scroll
       is never interrupted. */
    function fitRoot(panel) {
      var list = panel.querySelector('.hm-plain');
      if (!list) return;
      var cs = getComputedStyle(panel);
      var room = vpH() - panel.getBoundingClientRect().top - px(cs.paddingTop) - px(cs.paddingBottom) - EDGE;
      var next = Math.max(200, Math.round(room)) + 'px';
      if (list.style.maxHeight !== next) list.style.maxHeight = next;
    }

    /* Levels 2 and 3.
       Reads only — no style is cleared, so scrollTop survives. */
    function place(sub) {
      var item = sub.parentElement;
      if (!item) return;
      var box = item.closest('.hm-plain__sub') || item.closest('.hm-fly--plain');
      if (!box) return;

      var H = vpH(), W = vpW();
      var cs = getComputedStyle(sub);
      var bt = px(cs.borderTopWidth), bb = px(cs.borderBottomWidth);

      /* natural height without touching max-height: scrollHeight already
         covers content + padding, so only the borders are missing */
      var h = sub.scrollHeight + bt + bb;

      /* natural width, measured once on first open while left is still 0.
         scrollbar-gutter:stable keeps it constant afterwards. */
      if (!sub._hmW) sub._hmW = sub.getBoundingClientRect().width;
      var w = sub._hmW;

      var ir = item.getBoundingClientRect();
      var br = box.getBoundingClientRect();

      /* vertical · align the first row with the parent row, then clamp so
         the bottom edge always lands above the fold */
      var top = ir.top - px(cs.paddingTop) - bt;
      if (top + h > H - EDGE) top = H - EDGE - h;
      if (top < EDGE) top = EDGE;
      var room = H - EDGE - top;

      /* horizontal · sit against the parent panel, flip left if no room */
      var left = br.right - LAP;
      if (left + w + EDGE > W) {
        left = br.left - w + LAP;
        if (left < EDGE) left = Math.max(EDGE, W - w - EDGE);
      }

      write(sub, 'top', Math.round(top) + 'px');
      write(sub, 'left', Math.round(left) + 'px');
      write(sub, 'maxHeight', Math.round(room) + 'px');
    }

    /* only touch the style object when the value really changed —
       a no-op write still costs a layout pass and can nudge scrollTop */
    function write(el, prop, val) {
      if (el.style[prop] !== val) el.style[prop] = val;
    }

    /* ---------- open / close state ---------- */

    function shut(sub) {
      if (!sub) return;
      sub.classList.remove('is-open');
      qa('.hm-plain__sub.is-open', sub).forEach(function (s) { s.classList.remove('is-open'); });
    }

    function hold(item) {                 /* cancel pending closes up the chain */
      var a = item;
      while (a) {
        if (a._hmT) { clearTimeout(a._hmT); a._hmT = null; }
        a = a.parentElement ? a.parentElement.closest('.hm-plain__item') : null;
      }
    }

    function enter(item) {
      hold(item);
      var list = item.parentElement;
      if (list) {                          /* close whatever else is open here */
        for (var i = 0; i < list.children.length; i++) {
          if (list.children[i] !== item) shut(subOf(list.children[i]));
        }
      }
      var sub = subOf(item);
      if (!sub) return;
      var fresh = !sub.classList.contains('is-open');
      if (fresh) {
        sub.classList.add('is-open');
        sub.scrollTop = 0;
        place(sub);
      }
      /* already open: leave it exactly where it is, mid-scroll or not */
    }

    /* ---------- wiring ---------- */

    qa('.hm-nav__node[data-hm-kind="m_plain"]').forEach(function (node) {
      node.addEventListener('mouseenter', function () {
        if (!wide.matches) return;
        var panel = node.querySelector('.hm-fly--plain');
        if (panel) fitRoot(panel);
      });

      node.addEventListener('mouseover', function (e) {
        if (!wide.matches || !e.target || !e.target.closest) return;
        var item = e.target.closest('.hm-plain__item');
        if (item) enter(item);
      });

      node.addEventListener('focusin', function (e) {
        if (!wide.matches || !e.target || !e.target.closest) return;
        var item = e.target.closest('.hm-plain__item');
        if (item) enter(item);
      });

      node.addEventListener('mouseleave', function () {
        qa('.hm-plain__sub.is-open', node).forEach(function (s) { s.classList.remove('is-open'); });
      });

      /* grace timer: crossing the parent's padding on the way to the
         submenu is a mouseleave, so never close instantly */
      qa('.hm-plain__item.has-kids', node).forEach(function (item) {
        item.addEventListener('mouseleave', function () {
          if (!wide.matches) return;
          item._hmT = setTimeout(function () { shut(subOf(item)); }, GRACE);
        });
      });
    });

    /* Reposition only what actually moved. A panel scrolling its own
       content does not move its anchor, so it is excluded — that self-
       reposition is what froze the list in place. */
    var pending = false, src = null;
    function reflow() {
      if (pending || !wide.matches) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var from = src; src = null;
        qa('.hm-nav__node[data-hm-kind="m_plain"]:hover .hm-fly--plain').forEach(fitRoot);
        qa('.hm-plain__sub.is-open').forEach(function (s) {
          if (from && (s === from || s.contains(from))) return;   /* its own scroll */
          place(s);
        });
      });
    }

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      src = (t && t.nodeType === 1) ? t : null;
      reflow();
    }, true);
    window.addEventListener('resize', function () { src = null; reflow(); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { src = null; reflow(); });
    }
  })();










  
  window.Helm = { open: Overlay.open, close: Overlay.close, cart: Cart };
})();